module.exports = __webpack_public_path__ + "img/icon_L2.6e9d359d.png";